module.exports = class {
    onCreate(input) {
        this.state = {
            placementId: input.id,
            module: input.module,
            options: input.options
        };
    }

    onInput(input) {
        if (this.state.module !== input.module) {
            this.state.module = input.module;
            this.state.options = input.options;
        }
    }

    onMount() {
        document.addEventListener(`deli-received-response-PLACEMENT_${this.state.placementId}`, ({ detail }) => {
            this.setState({
                module: detail
            });
        });
    }
};
